import React from "react";
import img from "../../../../assets/Icon-Module-not-purchased-mcolour.svg";
import { getLabel, setTitle } from "@weapp/utils";
import { mainClsPrefix } from '../../../../constants';
import "./style/index.less";

const prefixCls = `${mainClsPrefix}-display-module-tip`

export class DisplayModuleTipProps {

}

export default class DisplayModuleTip extends React.Component<DisplayModuleTipProps> {
  componentDidMount() {
    setTitle({ 'title': getLabel('152193', '提示信息') });
  }
  render() {
    return (
      <div className={`${prefixCls}`}>
        <div className={`${prefixCls}-container`}>
          <img className={`${prefixCls}-icon`} src={img} />
          <div className={`${prefixCls}-text`}>{getLabel('244490', '模块未启用，请联系管理员！')}</div>
        </div>
      </div>
    )
  }
}